import React from 'react';
import { Check, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const plans = [{
  name: 'Free',
  price: '$0',
  period: 'forever',
  description: 'Perfect for getting started',
  features: ['Up to 2 bank accounts', 'Basic spending tracker', 'Monthly budget overview', 'AI chat (10 msgs/day)', 'Mobile app access'],
  cta: 'Get started free',
  highlighted: false
}, {
  name: 'Pro',
  price: '$9.99',
  period: '/month',
  description: 'For serious money managers',
  features: ['Unlimited bank accounts', 'Advanced AI insights', 'Investment tracking', 'Goal planner', 'Credit score monitoring', 'Unlimited AI chat', 'Priority support'],
  cta: 'Start Pro trial',
  highlighted: true
}, {
  name: 'Premium',
  price: '$19.99',
  period: '/month',
  description: 'For wealth builders',
  features: ['Everything in Pro', 'Tax optimization tips', 'Custom financial reports', 'Dedicated advisor access', 'Family sharing (5 users)', 'API access', 'White-glove onboarding'],
  cta: 'Start Premium trial',
  highlighted: false
}];
export function PricingSection() {
  const navigate = useNavigate();
  return <section className="py-20 bg-white dark:bg-dark-surface" data-id="element-909">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-910">
        <div className="text-center mb-14" data-id="element-911">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-widest mb-3" data-id="element-912">
            Pricing
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white mb-4" data-id="element-913">
            Simple, transparent pricing
          </h2>
          <p className="text-lg text-gray-500 dark:text-gray-400" data-id="element-914">
            Start free, upgrade when you're ready. No hidden fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-915">
          {plans.map((plan, i) => <div key={i} className={`relative rounded-2xl p-6 ${plan.highlighted ? 'bg-primary-500 text-white shadow-2xl scale-105 border-0' : 'bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border shadow-sm'}`} data-id="element-916">
              {plan.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-917">
                  <span className="bg-accent-500 text-black text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1" data-id="element-918">
                    <Zap size={11} data-id="element-919" /> Most Popular
                  </span>
                </div>}

              <div className="mb-5" data-id="element-920">
                <p className={`text-sm font-semibold mb-1 ${plan.highlighted ? 'text-primary-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-921">
                  {plan.name}
                </p>
                <div className="flex items-baseline gap-1" data-id="element-922">
                  <span className={`text-4xl font-black ${plan.highlighted ? 'text-white' : 'text-gray-900 dark:text-white'}`} data-id="element-923">
                    {plan.price}
                  </span>
                  <span className={`text-sm ${plan.highlighted ? 'text-primary-200' : 'text-gray-400'}`} data-id="element-924">
                    {plan.period}
                  </span>
                </div>
                <p className={`text-sm mt-1 ${plan.highlighted ? 'text-primary-200' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-925">
                  {plan.description}
                </p>
              </div>

              <button onClick={() => navigate('/signup')} className={`w-full py-2.5 rounded-xl text-sm font-semibold mb-5 transition-all hover:scale-105 active:scale-95 ${plan.highlighted ? 'bg-accent-500 hover:bg-accent-600 text-black' : 'bg-primary-500 hover:bg-primary-600 text-white'}`} data-id="element-926">
                {plan.cta}
              </button>

              <ul className="space-y-2.5" data-id="element-927">
                {plan.features.map((feature, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-928">
                    <Check size={14} className={`mt-0.5 shrink-0 ${plan.highlighted ? 'text-accent-400' : 'text-primary-500'}`} data-id="element-929" />
                    <span className={`text-sm ${plan.highlighted ? 'text-primary-100' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-930">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}